/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Ahmed Ali',
        title: 'Senior Product Manager',
        text: "Abdullah's expertise in React Native and mobile development helped us launch our iOS and Android apps 40% faster than projected. His attention to performance optimization and clean code practices is exceptional.",
        image: boy1
    },
    {
        id: 2,
        name: 'Zamair Rajpoot',
        text: "Working with Abdullah on our MERN stack application was a game-changer. His proficiency in Node.js, Express, and MongoDB helped us build a scalable backend that handles 10,000+ concurrent users seamlessly.",
        image: boy2
    },
    {
        id: 3,
        name: 'Inzer Mubasshar',
        title: 'Frontend Team Lead',
        text: "Abdullah's React and TypeScript skills are outstanding. He transformed our legacy codebase into a modern, maintainable application. His code reviews and mentoring have elevated our entire team's performance.",
        image: girl1
    },
    {
        id: 4,
        name: 'Awais',
        text: "The AWS infrastructure Abdullah designed for our applications is rock-solid. His understanding of cloud services, database optimization, and Git workflows has made our deployment process incredibly efficient.",
        image: boy1
    },
    {
        id: 5,
        name: 'Aqsa Sajid',
        title: 'UX Designer',
        text: "Collaborating with Abdullah on our design-to-code workflow has been fantastic. His Figma integration skills and ability to translate complex designs into pixel-perfect React components is remarkable.",
        image: girl3
    },
    {
        id: 6,
        name: 'Waqas Khan',
        title: 'Database Administrator',
        text: "Abdullah's database design and optimization skills are top-notch. He helped us migrate from MySQL to PostgreSQL and improved our query performance by 60%. His understanding of both SQL and NoSQL databases is impressive.",
        image: boy3
    }
]

